import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var OwlShopActions = require("lib/actions/OwlShopActions");
var OwlShopSelectors = require("lib/selectors/OwlShopSelectors");
var Modal = require('components/utility/AltModal');
var OwlShopDisplay = require("components/avatars/OwlShopDisplay");
var CurrentUser = require('lib/account/CurrentUser');
var OwlShopRouting = require("lib/routing/OwlShopRouting");

require("games/new_items_modal.scss");

@connect(
	(state, ownProps) => ({
		filteredPatches: OwlShopSelectors.getFilteredPatches({ state }),
		filteredPerks: OwlShopSelectors.getFilteredPerks({ state }),
		user: CurrentUser.get(),
	}),
	(dispatch, props) => ({
		populateData: () =>
			Promise.all([
				dispatch(OwlShopActions.fetchPatches()),
				dispatch(OwlShopActions.fetchPerks())
			]),
	}),
)

@providePopulateData({ waitForLoad: true })
class NewItemsModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { activeItemType: 'head', newItems: [], hide: false };
	}

	show() {
		this.refs.modal.show();
	}

	hide() {
		this.refs.modal.hide();
	}

	deleteAlert() {
		if (this.props.alertID) {
			CurrentUser.api().deleteUserAlert(this.props.alertID, () => {
				this.setState({ hide: true });
			});
		}
	}

	changeCategory(itemType) {
		this.setState({ activeItemType: itemType })
	}

	selectItem(item, equipType) {
		if (item.perk_type && item.perk_type == "houses") {
			var itemType = item.perk_type
		} else {
			var itemType = item.patch_type + "&patch=true"
		}

		var params = "?itemName=" + item.name + "&itemType=" + itemType

		$wr.redirect(OwlShopRouting.getPath({}) + params)
	}

	//////// Helper Methods ///////////
	initNewItems() {
		var { filteredPatches, filteredPerks } = this.props
		var newItems = _.sortBy(_.filter([...filteredPatches, ...filteredPerks], function (item) {
			return _.includes(newItemNames, item.name)
		}), item => { return item.tier + item.price });

		this.setState({ newItems })
	}

	// to keep category selector highlighted correctly in hand and body special cases
	isActivePatchType(patchType) {
		var { activeItemType } = this.state
		if (
			activeItemType == "left_hand" ||
			activeItemType == "hand" ||
			activeItemType == "wings"
		) {
			return patchType == "left_hand";
		} else if (activeItemType == "body" || activeItemType == "body2") {
			return patchType == "body";
		} else {
			return patchType == activeItemType;
		}
	}

	//////// Render Methods ///////////
	renderCategorySelector(text, patchType, otherType) {
		let categoryClass;
		if (this.props.activePatchType && this.isActivePatchType(patchType)) {
			categoryClass = "selector selectedPatchType";
		} else if (this.props.activeOtherType && this.props.activeOtherType == otherType) {
			categoryClass = "selector selectedPatchType";
		} else {
			categoryClass = "selector"
		}

		return (
			<a onClick={() => this.changeCategory(patchType || otherType)} className={categoryClass}>
				<img src={dynamicRequire("owl-item-types/" + (patchType || otherType) + ".png")} />
				<span className="categoryTitle">{text}</span>
			</a>
		);
	}

	renderOwlshopCategories() {
		if (!this.props.hideOwls) {
			var owlCustomizers = (
				<div>
					{this.renderCategorySelector("Head", "head", null)}
					{this.renderCategorySelector("Face", "face", null)}
					{this.renderCategorySelector("Body", "body", null)}
					{this.renderCategorySelector("Wings", "left_hand", null)}
					{this.renderCategorySelector("Houses", null, "houses")}
				</div>
			);
		}
		return (
			<div className="categorySelector">
				<div className="categorySection">
					<div className="modeSelectorRowContainer">
						{owlCustomizers}
					</div>
				</div>
			</div>
		);
	}

	renderOwlshopItems() {
		var { activeItemType, newItems } = this.state

		var items = _.filter(newItems, function (item) {
			return (item.perk_type == activeItemType || item.patch_type == activeItemType) && _.includes(newItemNames, item.name)
		});

		return (
			<OwlShopDisplay
				user={this.props.user}
				itemType={activeItemType}
				items={items}
				hideAlternates={true}
				selectItem={this.selectItem}
				isPatch={!(activeItemType == 'houses')}
			/>
		);
	}

	renderSubheadline() {
		return (
			<div className="subheadline">Shop new styles and houses to bring in the New Year!</div>
		)
	}

	renderOwlImages() {
		return (
			<div className="owlImages">
				<img src={require("owls/new_owl_1.png")} key="new_owl_1" />
				<img src={require("owls/new_owl_2.png")} key="new_owl_2" />
				<img src={require("owls/new_owl_3.png")} key="new_owl_3" />
			</div>
		)
	}

	render() {
		if (this.state.hide) { return null }
		return (
			<Modal onHide={this.deleteAlert} className="newItemsModal wideModal" headerText={this.props.title}
				ref="modal">
				{this.renderOwlImages()}
				{this.renderSubheadline()}
				{this.renderOwlshopCategories()}
				{this.renderOwlshopItems()}
			</Modal>
		);
	}

	componentDidUpdate(prevProps) {
		var { filteredPatches, filteredPerks } = this.props
		if (prevProps.filteredPatches != filteredPatches || prevProps.filteredPerks != filteredPerks) {
			this.initNewItems()
		}
	}

	componentDidUpdate() {
		if (this.props.open && this.refs.modal) {
			this.refs.modal.show();
		}
	}

	componentDidMount() {
		if (this.props.open && this.refs.modal) {
			this.refs.modal.show();
		}
		this.initNewItems()
	}
}

NewItemsModal.propTypes = PageStrictPropTypes({
	saleData: PropTypes.object,
	filteredPatches: PropTypes.array,
	filteredPerks: PropTypes.array,
	activePatchType: PropTypes.string,
	title: PropTypes.string,
	alertID: PropTypes.number,
	open: PropTypes.bool
});

module.exports = NewItemsModal;

const newItemNames = [
	'binoculars',
	'earbuds-blue',
	'earbuds-pink',
	'earbuds-white',
	'earbuds-yellow',
	'expression-rage',
	'expression-shock',
	'makeup-blue',
	'makeup-pink',
	'makeup-gold',
	'makeup-diva',
	'makeup-sunset',
	'pink-heart-glasses',
	'goggles-VR',
	'afro-hair',
	'army-helmet',
	'big-wig',
	'bunny-ears',
	'cat-ears',
	'diver-helmet',
	'dog-ears',
	'earrings-flower',
	'earrings-pearl',
	'earrings-ruby',
	'fox-ears',
	'headscarf',
	'mouse-ears',
	'plunger-hat',
	'hair-ringlets-black',
	'spiky-hair',
	'bun',
	'unicorn-crown',
	'coat',
	'denim-jacket',
	'fannypack',
	'floatie-alligator',
	'floatie-donut',
	'floatie-toucan',
	'floatie-watermelon',
	'heart-skirt',
	'holiday-sweater',
	'hoodie-blue',
	'hoodie-orange',
	'hoodie-finger-heart-brown',
	'hoodie-finger-heart-white',
	'ripped-jeans',
	'motorcycle-jacket',
	'overalls-denim',
	'overalls-red',
	'party-dress',
	'puffy-jacket-pink',
	'school-girl-uniform',
	'sweater',
	'swimsuit-neon-green',
	'swimsuit-red-stripe',
	'swimsuit-yellow',
	'tiger-suit',
	'trenchcoat',
	'magic-wand-right',
	'pink-diamond-right',
	'balloon-purple-heart-right',
	'rabbit-in-hat-right',
	"Luxury Apartments",
	"Owl-Dobe Desert Casa",
	"Barn House",
	"Hawaiian Beach Hut",
	"Sir Hoots A Lot's Castle",
	"Festival Yurt",
	"Owl-ffel Tower",
	"Gingerbread House",
	"Modern Glass House",
	"Rainbow Hot Air Balloon",
	"Purple Hot Air Balloon",
	"Red Hot Air Balloon",
	"Japanese Restaurant",
	"Leaning T-owl-er of Pisa",
	"Lighthouse",
	"Log Cabin",
	"Modern Mansion",
	"Mongolian House",
	"Eagle's Nest",
	"Space Vision House",
	"Pirate Ship",
	"Rocket Ship",
	"Tree House",
	"Medieval Tower",
	"Windmill"
]


// WEBPACK FOOTER //
// ./modules/components/games/NewItemsModal.js